export default __webpack_public_path__ + "static/media/dedicated-whatif.0c6bcf72.svg";